import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,

  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import PersonIcon from "@mui/icons-material/Person";

import { NavLink, useNavigate } from "react-router-dom";
import { RootState } from "../../Storage/Redux/store";
import { useSelector, useDispatch } from "react-redux";
import {
  emptyUserState,
  setLoggedInUser,
} from "../../Storage/Redux/userAuthSlice";
import { useGetLeaderboardQuery } from "../../Apis/progressApi";
import {  useState } from "react";

let logo2 = require("../../Assets/Images/ditgal-center-logo.png");
export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userData = useSelector((state: RootState) => state.userAuthStore);
const { data: leaderboardData } = useGetLeaderboardQuery(undefined, {
  skip: !userData.nameid || userData.role === "Admin",
});
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mobileMenu, setMobileMenu] = useState<null | HTMLElement>(null);

  const openMenu = Boolean(anchorEl);
  const openMobileMenu = Boolean(mobileMenu);

 

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch(setLoggedInUser({ ...emptyUserState }));
    navigate("/Login");
  };
  
  const currentUserRank = leaderboardData?.currentUserRank || 0;



  const currentUserScore = leaderboardData?.currentUserScore || 0;

  return (
    <>
      {/* MAIN HEADER */}
      <AppBar position="static" sx={{ backgroundColor: "rgba(81,35,132,1)" }}>
        <Toolbar disableGutters sx={{ px: 1.5 }}>
          {/* LOGO */}
          <Box
            component={NavLink}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              mr: 3,
            }}
          >
            <Box
              component="img"
              src={logo2}
              alt="Logo"
              sx={{ height: 35, width: "auto" }}
            />
          </Box>

          {/* ADMIN MENU — LEFT SIDE */}
          {userData.nameid && userData.role === "Admin" && (
            <Button
              color="inherit"
              startIcon={<SettingsIcon />}
              onClick={(e) => setAnchorEl(e.currentTarget)}
              sx={{
                textTransform: "none",
                display: { xs: "none", md: "flex" },
              }}
            >
              Contest Management
            </Button>
          )}

          <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem component={NavLink} to="/Campaign/List">
              Campaign Management
            </MenuItem>

            <MenuItem component={NavLink} to="/Quiz/List">
              Quiz Management
            </MenuItem>

            <MenuItem component={NavLink} to="/Question/List">
              Questions
            </MenuItem>

            <Divider />

            <MenuItem component={NavLink} to="/Users">
              Users Management
            </MenuItem>
          </Menu>

          {/* SPACER */}
          <Box sx={{ flexGrow: 1 }} />

          {/* RIGHT SIDE — AUTH */}
          {userData.nameid ? (
            <>
              <Typography
                sx={{
                  color: "white",
                  mr: 2,
                  display: { xs: "none", md: "block" },
                }}
              >
                Welcome {userData.fullName}
              </Typography>

              <IconButton
                color="error"
                onClick={handleLogout}
                sx={{ display: { xs: "none", md: "flex" } }}
              >
                <LogoutIcon />
              </IconButton>
            </>
          ) : (
            <>
              <Button
                component={NavLink}
                to="/login"
                color="inherit"
                sx={{ display: { xs: "none", md: "flex" } }}
              >
                Login
              </Button>
              <Button
                component={NavLink}
                to="/Register"
                color="inherit"
                sx={{ display: { xs: "none", md: "flex" } }}
              >
                Register
              </Button>
            </>
          )}

          {/* MOBILE MENU BUTTON */}
          
          {userData.role === "Admin" &&(
          <IconButton
            color="inherit"
            sx={{ display: { xs: "flex", md: "none" } }}
            onClick={(e) => setMobileMenu(e.currentTarget)}
          >
            <MenuIcon />
          </IconButton>)}
          {userData.nameid ? (
            <IconButton
              color="error"
              onClick={handleLogout}
              sx={{ display: { xs: "flex", md: "none" }}}
            >
              <LogoutIcon />
            </IconButton>
          ):(<>
              <Button
                component={NavLink}
                to="/login"
                color="inherit"
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Login
              </Button>
              <Button
                component={NavLink}
                to="/Register"
                color="inherit"
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Register
              </Button>
            </>)}
        </Toolbar>
      </AppBar>

      {/* MOBILE MENU */}
      <Menu
        anchorEl={mobileMenu}
        open={openMobileMenu}
        onClose={() => setMobileMenu(null)}
      >
        {!userData.nameid
          ? [
              <MenuItem key="login" component={NavLink} to="/login">
                Login
              </MenuItem>,
              <MenuItem key="register" component={NavLink} to="/Register">
                Register
              </MenuItem>,
            ]
          : [
              ...(userData.role === "Admin"
                ? [
                    <MenuItem key="c1" component={NavLink} to="/Campaign/List">
                      Campaign Management
                    </MenuItem>,
                    <MenuItem key="c2" component={NavLink} to="/Quiz/List">
                      Quiz Management
                    </MenuItem>,
                    <MenuItem
                      key="c3"
                      component={NavLink}
                      to="/Question/Create"
                    >
                      Questions
                    </MenuItem>,
                    <Divider key="d1" />,
                    <MenuItem key="c4" component={NavLink} to="/Users">
                      Users Management
                    </MenuItem>,
                    <Divider key="d2" />,
                  ]
                : []),
              
            ]}
      </Menu>

      {/* CUSTOMER BANNER */}
      {userData.role === "Customer" && (
        <Box
          sx={{
            backgroundColor: "#eb3c96",
            color: "#fff",
            textAlign: "center",
            py: 0.6,
            fontSize: "0.85rem",
            fontWeight: 600,
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {currentUserScore > 0 ? (
            <>
              <PersonIcon sx={{ fontSize: 18}} />{" "}
              {userData.fullName}
              &nbsp;|&nbsp;
              <StarIcon sx={{ fontSize: 18 }} /> {currentUserScore}
              &nbsp;|&nbsp;
              <EmojiEventsIcon sx={{ fontSize: 18 }} />{" "}
              {currentUserRank}
            </>
          ) : (
            <>Welcome {userData.fullName}! Your results will appear here!</>
          )}
        </Box>
      )}
    </>
  );
}
